import Backbone from "backbone";
import mapService from "../../common/services/mapService";


  export default Backbone.View.extend({

    model: null,

    initialize: function initialize(options) {

      this.renderOptions = {
        initTemplate: false
      };

      this.initializeMap = this.initializeMap.bind(this);
      this.geoloc = options.geoloc;
      this.initializeMap();
    },

    initializeMap: function initializeMap() {
      // Load map service
      mapService.on('load:desktop', () => {
        var storeLocation = convertStrGeolocToLatLng(this.geoloc);
        var map = mapService.create(this.$el.find('.js-map')[0]);
        map.setView({
          center: storeLocation,
          zoom: 14
        });
        // Create pushpin
        var pushpin = new Microsoft.Maps.Pushpin(storeLocation, {
          icon: mapService.icon({ type: 'relay', selected: true })
        });
        map.entities.push(pushpin);
      });

      mapService.load('desktop');
    }
  });

  /**
   * Convert your string geolocation into bing map object.
   * @param {string} geoloc String geolocalisation formatted as '(x.x, y.y)'
   * @returns {object} LatLng bing map object. It defines latitude/longitude.
   */
  function convertStrGeolocToLatLng(geoloc) {
    if (typeof geoloc == 'undefined' && geoloc === '') {
      console.error(new Error('<!> geoloc is empty or null'));
      return null;
    }
    var geolocWithoutParenthesis = geoloc.substr(1, geoloc.length - 2);
    var geolocArray = geolocWithoutParenthesis.split(',');

    var gPoint = new Microsoft.Maps.Location(geolocArray[0], geolocArray[1]);
    return gPoint;
  }
